import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}/phone-verification`;

const getVerificationCode = async data => {
    const uri = `${getApiService()}/phonenumber`;
    const response = await HTTPClient().postJson(uri, data);

    return response.json();
};

const validateVerificationCode = async data => {
    const uri = `${getApiService()}/validation`;
    const response = await HTTPClient().postJson(uri, data);

    return response.json();
};

export default {
    getVerificationCode,
    validateVerificationCode,
};
